import { FAQData, FAQGroup } from './types';

export function filterFaqData(data: FAQData, searchTerm: string): FAQData {
  if (!searchTerm.trim()) {
    return data;
  }

  const query = searchTerm.toLowerCase();
  const filteredGroups = data.groups
    .map((group) => {
      const filteredItems = group.items.filter(
        (item) =>
          item.question.toLowerCase().includes(query) || item.answer.toLowerCase().includes(query),
      );
      if (filteredItems.length > 0) {
        return { ...group, items: filteredItems };
      }
      return null;
    })
    .filter((group): group is FAQGroup => group !== null);

  return { groups: filteredGroups };
}

export function expandedGroupsForSearch(groups: FAQGroup[]): Set<string> {
  return new Set(groups.map((group) => group.group));
}

export function toggleExpandedGroup(expandedGroups: Set<string>, groupName: string): Set<string> {
  const next = new Set(expandedGroups);
  if (next.has(groupName)) {
    next.delete(groupName);
  } else {
    next.add(groupName);
  }
  return next;
}

export function shouldExpandGroupsForSearch(
  nextGroups: Set<string>,
  currentGroups: Set<string>,
): boolean {
  if (nextGroups.size !== currentGroups.size) {
    return true;
  }

  return !Array.from(nextGroups).every((group) => currentGroups.has(group));
}
